import { render, staticRenderFns } from "./fila_atendimentos.vue?vue&type=template&id=900fa3b6&scoped=true"
import script from "./fila_atendimentos.vue?vue&type=script&lang=js"
export * from "./fila_atendimentos.vue?vue&type=script&lang=js"
import style0 from "./fila_atendimentos.vue?vue&type=style&index=0&id=900fa3b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900fa3b6",
  null
  
)

export default component.exports